import { awardPoints } from "@circle-react/components/SettingsApp/Workflows/components/Actions/Gamification/awardPoints";
import {
  addCommunityMemberToAccessGroup,
  removeCommunityMemberFromAccessGroup,
} from "./AccessGroup";
import { hidePostFromFeaturedAreas } from "./AiAgents/hidePostFromFeaturedAreas/hidePostFromFeaturedAreas";
import { postComment } from "./AiAgents/postComment/postComment";
import { renamePostTitle } from "./AiAgents/renamePostTitle/renamePostTitle";
import { reportComment } from "./AiAgents/reportComment/reportComment";
import { reportPost } from "./AiAgents/reportPost/reportPost";
import { sendDM as aiAgentsSendDM } from "./AiAgents/sendDM/sendDM";
import { rsvpMemberToEvent } from "./Event";
import { timeDelay } from "./Flow/TimeDelay";
import {
  disableMessaging,
  enableMessaging,
  removeMember,
  sendDM,
  sendEmail,
  sendPushNotification,
  unsubscribe,
} from "./Member";
import { addTag, removeTag } from "./MemberTag";
import {
  cancelSubscriptionFromPaywall,
  cancelSubscriptionImmediatelyFromPaywall,
  subscribeToPaywallTrial,
} from "./Paywall";
import { addMemberToSpace, removeMemberFromSpace } from "./Space";
import {
  addMemberToSpaceGroup,
  removeMemberFromSpaceGroup,
} from "./SpaceGroup";
import { sendToWebhook } from "./Webhook";

export const availableActions = [
  postComment,
  reportPost,
  reportComment,
  hidePostFromFeaturedAreas,
  renamePostTitle,
  sendEmail,
  sendDM,
  addTag,
  removeTag,
  removeMember,
  addMemberToSpace,
  removeMemberFromSpace,
  addMemberToSpaceGroup,
  removeMemberFromSpaceGroup,
  addCommunityMemberToAccessGroup,
  removeCommunityMemberFromAccessGroup,
  sendToWebhook,
  cancelSubscriptionFromPaywall,
  cancelSubscriptionImmediatelyFromPaywall,
  subscribeToPaywallTrial,
  rsvpMemberToEvent,
  sendPushNotification,
  enableMessaging,
  disableMessaging,
  timeDelay,
  awardPoints,
  unsubscribe,
  aiAgentsSendDM,
] as const;
